var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 18,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.633.692v2.652H8.056c-.576 0-.964.12-1.165.36-.2.242-.3.604-.3 1.086v1.9h2.94l-.39 2.972H6.59v7.624H3.515V9.662H.955V6.69h2.56V4.5c0-1.247.35-2.213 1.045-2.9C5.257.916 6.184.57 7.343.57c.984 0 1.747.042 2.29.122z"
})));
export { SvgFacebook as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiYWMwYzQ4ZmNiMjI5NjA4NWUzMzU1ZTAxZWZkNDQ0NmUuc3ZnIjs=";